module.exports = __webpack_public_path__ + "static/media/kenya-flag-round-small.3a80d3ed.jpg";